import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';
import { authManager } from 'redux/action/auths';
import AuthEditHeader from './AuthEditHeader';
import SafetyAuthEdit from './SafetyAuthEdit';
import FactoryInnerAuthEdit from './FactoryInnerAuthEdit';
import { customAxiosPostFunction } from 'utils/axiosFunction';
import { AuthEditContainer } from './AuthEditMain.css';

const AuthEditMain = ({ auths, selectAuth, setSelectAuth }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [inputAuth, setInputAuth] = useState({ authIdx: 0, authNm: '', level: 1, memo: '', manageTargetAuth: null, parentAuth: null });
  const { register, handleSubmit, errors } = useForm();

  const submit = (data) => {
    const url = selectAuth ? '/api/auth/updateData' : '/api/auth/insertData';
    const manageTargetAuth = Number(data.level) === 2 ? data.manageTargetAuth.join(',') : data.manageTargetAuth;

    customAxiosPostFunction(history, url, { ...data, manageTargetAuth, authIdx: inputAuth.authIdx }).then((response) => {
      if (response === 200) {
        alert('저장되었습니다');
        dispatch(authManager());
        setInputAuth({ authIdx: 0, authNm: '', level: 1, memo: '', manageTargetAuth: null, parentAuth: null });
        setSelectAuth(null);
      } else {
        alert('업데이트에 실패');
      }
    });
  };

  useEffect(() => {
    if (selectAuth !== null) {
      setInputAuth(selectAuth);
    }
  }, [selectAuth]);

  return (
    <AuthEditContainer>
      <form onSubmit={handleSubmit(submit)}>
        <AuthEditHeader selectAuth={selectAuth} setSelectAuth={setSelectAuth} inputAuth={inputAuth} setInputAuth={setInputAuth} register={register} />
        {inputAuth.level === 2 && (
          <SafetyAuthEdit
            saftyAuths={auths.filter((auth) => auth.level === 3)}
            manageTargetAuth={inputAuth.manageTargetAuth ? inputAuth.manageTargetAuth : ''}
            register={register}
          />
        )}
        {inputAuth.level === 4 && (
          <FactoryInnerAuthEdit factoryAuths={auths.filter((auth) => auth.level === 3)} register={register} inputAuth={inputAuth} />
        )}
      </form>
    </AuthEditContainer>
  );
};

export default AuthEditMain;
